export default __webpack_public_path__ + "static/SofiaProSemiBold-b1f437b9ad2e61271a5afc71ac9fff75.woff2";